module.exports = __webpack_public_path__ + "img/product.94068c65.jpg";